import {
  Box,
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useEffect, useState } from "react";
import {
  handleCommonFindRequest,
  handleCommonGetRequest,
} from "rest-data-provider/utils/tools";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import { config } from "config";
import { ReadableText } from "components/readableText";
const DebugModules = config().debugModules;

const App = () => {
  const { state } = useLocation();

  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
    setValue,
  } = useForm();

  const isEdit = !!state;

  const [userId, setUserId] = useState<string>((isEdit && state.userId) || "");
  const [email, setEmail] = useState<string>((isEdit && state.email) || "");
  const [modules, setModules] = useState<string[]>(
    (isEdit && state.modules) || []
  );

  useEffect(() => {
    if (isEdit) {
      setValue("userId", state.userId);
      setValue("email", state.email);
      setValue("modules", state.modules);
    }
  }, []);

  const handleChange = (event: SelectChangeEvent<typeof modules>) => {
    setModules(
      typeof event.target.value === "string"
        ? event.target.value.split(",")
        : event.target.value
    );
  };

  const unsetModules = () => {
    return modules.length === 0;
  };

  const getEmail = async () => {
    const data: any = await handleCommonGetRequest("users", userId);
    setEmail(data.email);
    setValue("email", data.email);
    return true;
  };

  const getUserId = async () => {
    const data: any = await handleCommonFindRequest("users", [
      {
        field: "email[$ilike]",
        value: `%${email}%`,
        operator: "eq",
      },
    ]);
    if (data.data.length) {
      setUserId(data.data[0].id);
      setValue("userId", data.data[0].id);
      return true;
    } else {
      window.alert("No current user");
      return false;
    }
  };

  const showTitle = (isEdit ? "Edit" : "Create") + " Analytics watch list";

  return (
    <Edit
      title={showTitle}
      isLoading={formLoading}
      saveButtonProps={saveButtonProps}
      headerButtonProps={{ style: { display: "none" } }}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("userId", {
            required: "This field is required",
            validate: () => getEmail(),
            onBlur: () => {
              getEmail();
            },
          })}
          error={!!(errors as any)?.userId}
          helperText={(errors as any)?.userId?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="UserId"
          name="userId"
          value={userId}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setUserId(event.target.value);
          }}
          disabled={isEdit}
        />
        <TextField
          {...register("email", {
            required: "This field is required",
            validate: () => getUserId(),
            onBlur: () => {
              getUserId();
            },
          })}
          error={!!(errors as any)?.email}
          helperText={(errors as any)?.email?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Email"
          name="email"
          value={email}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setEmail(event.target.value);
          }}
          disabled={isEdit}
        />
        <FormControl
          fullWidth
          style={{ marginTop: "10px", marginBottom: "10px" }}
          error={unsetModules()}
        >
          <InputLabel id="modules">Modules</InputLabel>
          <Select
            {...register("modules", {
              validate: () => {
                return !unsetModules();
              },
            })}
            multiple
            renderValue={(value) => (
              <ReadableText text={value.filter((i) => !!i).join(", ")} />
            )}
            labelId="modules"
            value={modules}
            label="Modules"
            onChange={handleChange}
          >
            {DebugModules.map((item: any) => {
              return (
                <MenuItem key={item.name} value={item.name}>
                  <Checkbox checked={modules.indexOf(item.name) > -1} />
                  <ListItemText primary={`${item.name}: ${item.description}`} />
                </MenuItem>
              );
            })}
          </Select>
          {unsetModules() && (
            <FormHelperText>Please select modules</FormHelperText>
          )}
        </FormControl>
      </Box>
    </Edit>
  );
};

export default App;
